module.exports = __webpack_public_path__ + "img/xbox-1.28e95fd6.png";